"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INTERACTION_STATE = void 0;
var INTERACTION_STATE;
(function (INTERACTION_STATE) {
    /** The event enum for mousedown and touchstart. */
    INTERACTION_STATE["DOWN"] = "down";
    /** The event enum for mousemove and touchmove. */
    INTERACTION_STATE["MOVE"] = "move";
    /** The event enum for mouseup, mouseout, touchcancel and touchup. */
    INTERACTION_STATE["END"] = "end";
    /** The event enum for mouseout and touchcancel. */
    INTERACTION_STATE["OUT"] = "out";
    /** The event enum for mouseup and touchup. */
    INTERACTION_STATE["UP"] = "up";
})(INTERACTION_STATE || (exports.INTERACTION_STATE = INTERACTION_STATE = {}));
//# sourceMappingURL=IInteractionEngine.js.map